;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('ModifyPaymentController', ModifyPaymentController)

  ModifyPaymentController.$inject = [
    // Angular
    '$uibModalInstance',

    // Services
    'UtilService', 'DatePickerService',

    // Resolve
    'payment', 'balance'

  ]

  function ModifyPaymentController (
    // Angular
    $uibModalInstance,

    // Services
    UtilService, DatePickerService,

    // Resolve
    payment, balance

  ) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        cancel: cancel,
        validate: validate,
        selectDate: selectDate,
        resetDate: resetDate
      })
      init()
    }

    function init () {
      if (payment) {
        payment.date = new Date(payment.date)
      }
      self.payment = payment || {}
    }

    function selectDate () {
      DatePickerService.getRange(self.payment.date).then(function (date) {
        self.payment.date = new Date(date)
        self.paymentForm.$dirty = true
      })
    }

    function resetDate () {
      self.payment.date = null
      self.paymentForm.$dirty = true
    }

    function validate () {
      $uibModalInstance.close(self.payment)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
